<script lang="ts" setup>
  import type { GiftCardSkin } from '~/types/api/gift-cards'

  const giftCardStore = useGiftCardsStore()

  const emit = defineEmits<{
    (event: 'design-selected', design: GiftCardSkin): void
  }>()

  // If group is first in the list, and the first five options, loading should be eager
  // Otherwise, loading should be lazy
  function getLoading(groupIndex: number, designIndex: number) {
    return groupIndex === 0 && designIndex <= 6
  }

  function handleDesignClick(design: any) {
    emit('design-selected', design)
  }
</script>

<template>
  <div class="c-gift-card-design gift-card-step-panel">
    <div class="step-header-content">
      <span class="text-button-medium">Grill'd gift cards</span>
      <h2 class="header-3">Choose Your Design</h2>
    </div>

    <div v-for="(group, groupIndex) in giftCardStore.data.skinGroups" :key="group.title" class="design-group">
      <h3 class="header-5">{{ group.title }}</h3>
      <div class="designs">
        <CLazyImage
          v-for="(design, designIndex) in group.skins"
          :key="design.id"
          :loading="getLoading(groupIndex, designIndex) ? 'eager' : 'lazy'"
          :preload="getLoading(groupIndex, designIndex)"
          :src="design.url"
          alt=""
          aspect-ratio="1.8"
          border-radius="4px"
          class="design-image"
          fit="cover"
          @click="handleDesignClick(design)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../styles/step.scss';

  .design-group {
    padding: 1.5rem 0;

    h3 {
      margin-bottom: 1rem;
    }

    .designs {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;

      .design-image {
        cursor: pointer;
      }

      @include screenSmAndUp {
        grid-template-columns: repeat(3, 1fr);
      }

      @include screenMdAndUp {
        grid-template-columns: repeat(4, 1fr);
      }

      @include screenXlAndUp {
        grid-template-columns: repeat(5, 1fr);
        gap: 24px;
      }
    }
  }
</style>
